import { Injectable } from "@angular/core";
import { BehaviorSubject, debounceTime, Subject, switchMap, tap } from "rxjs";
import { LocalStorageService } from "../persistance";
import { LocalStorageKey } from "@model";

import { playByteArray, stopPlaying } from "./byte-array-player.helper";
import { getPollyBitArray, getPollyClient } from "./aws.polly.helper";
import { PollyClient } from "@aws-sdk/client-polly";

@Injectable({
  providedIn: "root",
})
export class VoiceService {
  client: PollyClient;
  private _isSoundActive$ = new BehaviorSubject<boolean>(false);
  isSoundActive$ = this._isSoundActive$.asObservable();

  speak$ = new Subject<string>();

  constructor(private _localStorageService: LocalStorageService) {
    this.client = getPollyClient();
    this._checkStoredValue();

    this.speak$
      .pipe(
        debounceTime(100),
        switchMap((text) => {
          return getPollyBitArray(this.client, text);
        }),
        tap((bitArray) => {
          if (bitArray) {
            playByteArray(bitArray);
          }
        }),
      )
      .subscribe();
  }

  speak(text: string): void {
    if (text && this._isSoundActive$.value) {
      this.speak$.next(text);
    }
  }

  toggleSoundActive(): void {
    const isSoundActive = !this._isSoundActive$.value;
    this._localStorageService.set(LocalStorageKey.SOUND_ACTIVE, String(isSoundActive));
    this._isSoundActive$.next(isSoundActive);
    if (!isSoundActive) {
      stopPlaying();
    }
  }

  private _checkStoredValue(): void {
    const isSoundActive = this._localStorageService.get(LocalStorageKey.SOUND_ACTIVE) === "true";
    this._isSoundActive$.next(isSoundActive);
  }
}
